<template>
  <KeywordsMiniHeader
    :text="inputValue"
    :hidden="!showMiniHeader"
  />
  <KeywordsHeader
    :text="inputValue"
    :hidden="showMiniHeader"
  />
</template>

<script setup>
import KeywordsHeader from './KeywordsHeader.vue'
import KeywordsMiniHeader from './KeywordsMiniHeader.vue'
import { useEventListener } from '@vueuse/core'

const showMiniHeader = ref(false)

const route = useRoute()

const inputValue = computed(() => route.query.keyword)

useEventListener(window, 'scroll', (e) => {
  const scrollTop = e.target.scrollingElement.scrollTop
  if (scrollTop > 120) {
    showMiniHeader.value = true
  } else {
    showMiniHeader.value = false
  }
})
</script>

<style lang="less" scoped>

</style>
